import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService } from '../../services/tools/helpers.service';
import { ConveniosService } from '../../services/convenios.service';

@Component({
    selector: 'convenios-listado',
    templateUrl: './convenios-listado.component.html',
    styleUrls: ['./convenios-listado.component.scss']
  })

export class ConveniosListadoComponent implements OnInit {
  public errors:any = {};
  //UI vars
  public listaConvenios: object = [];
  public convenioToDelete = null;
  //Filters 
  public searchText: string = '';
  //Pagination vars
  public page: number = 1;
  public pageSize: number = 0;
  public pageAll: number = 0;
  public paginationInfo = { from : null, to : null, total : null };
  //Tipo de convenio
  public tipoSelected:any = {id:0};
  public tipoConDefault = "";
  public optTipoCon = [{id:0, nombre:"Todos los convenios"},{id:1, nombre:"Nómina"},{id:2, nombre:"Hipotecario"},{id:3, nombre:"Automotriz"},{id:4, nombre:"Prendario"},{id:5, nombre:"Verde"},
  {id:6, nombre:"Personal"},{id:7, nombre:"Credigas Carburación"},{id:8, nombre:"Credigas Estacionario"},{id:9, nombre:"Comercialización"},{id:10, nombre:"Maxi Pensión"}];
  

  constructor(
    private helperService : HelpersService,
    private location : Location,
    private activeRoute : ActivatedRoute,
    private router : Router,
    private conveniosService : ConveniosService
  ){
  }

  public ngOnInit() {
    this.getConvenios();
  }
  tipoChanged(tipo){
    console.log("Event Estado: ", tipo);
    
    if(tipo){
        this.tipoSelected = tipo;
        // this.convenio.tipo_convenio = this.tipoSelected.nombre;
        // console.log("Tipo convenio: ",this.convenio);
        // this.getGastosPorMes();
        this.getConvenios();
    }else{
      this.tipoSelected = this.optTipoCon[0];
      // this.convenio.tipo_convenio = this.tipoSelected.nombre;
    }
  }
  private selectTipo(tipo){
    this.tipoSelected = this.optTipoCon[0];
    // this.convenio.tipo_convenio = this.tipoSelected;
    for (let index = 0; index < this.optTipoCon.length; index++) {
      const element = this.optTipoCon[index];
      if(element.nombre === tipo){
        this.tipoSelected = this.optTipoCon[index];
        // this.convenio.tipo_convenio = tipo;
        break;
      }
      
    }
  }

  public getConvenios(){
    let filters = this.getActiveFilters();

    this.conveniosService.getAll(filters).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content && jsonResult.content.data){
          const jsonContent = response.json().content;
          this.listaConvenios = jsonContent.data;
          this.page = jsonContent.current_page;
          this.pageSize = jsonContent.per_page;
          this.pageAll = jsonContent.total;
          this.paginationInfo.from = jsonContent.from;
          this.paginationInfo.to = jsonContent.to;
          this.paginationInfo.total = jsonContent.total;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getActiveFilters(){
    let filters:any = {
      page : null,
      search : null,
      paginate : true,
    };

    if(this.page){
      filters.page = this.page;
    }

    if(this.searchText){
      filters.search = this.searchText;
    }
    if (this.tipoSelected.id!=0){
      // console.log("Hay un tipo seleccionado")
      filters.tipo=this.tipoSelected.nombre
      console.log(this.tipoSelected)
    }

    return filters;
  }

  public selectConvenio(convenio : any){
    //Navegar a los detalles del convenio
    this.router.navigate(['/convenios/detalles/', convenio.id]);
  }

  public selectConvenioToDelete(event : any, convenio : any){
    event.stopPropagation();
    this.convenioToDelete = convenio;
    document.getElementById("btnOpenModal").click();
  }

  public deleteConvenio(){
    let filters = this.getActiveFilters();

    this.conveniosService.delete(this.convenioToDelete.id).subscribe(
      (response)=>
      {
        const jsonContent = response.json().content;
        this.getConvenios();
        this.helperService.notification('Convenio eliminado', 'Se ha eliminado exitosamente el convenio', 'success');
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/convenios/listado/convenios-listado.component.ts